import { useId } from 'react';

/** The caller's id if provided, else a stable generated one — so every form
 *  field satisfies the browser's "needs id or name" requirement. */
export function useJcFieldId(id?: string): string {
  const generatedId = useId();
  return id ?? generatedId;
}
